import { Box, Flex, HStack, VStack } from "@chakra-ui/react";
import CDS from "design-system";
import { format, isToday, isTomorrow } from "date-fns";
import { Meeting } from "features/Resources/Meeting/models";
import { GeneralMeetingTypeTag } from "design-system";
import { meetingStartEnd } from "helpers/time";

export default function MeetingRow({ meeting }: { meeting: Meeting }) {
  const startDate = new Date(meeting.startTime);
  const dayLabel = isToday(startDate) ? "Today" : isTomorrow(startDate) ? "Tomorrow" : format(startDate, "EEE, MMM d");
  const timeLabel = meetingStartEnd(meeting.startTime, meeting.endTime);

  return (
    <Flex align="center" gap="3" py="6px" px={4} borderBottom="1px solid" borderColor="gray.100">
      <VStack spacing="0" minW="36px" bg="gray.50" borderRadius="md" px="1.5" py="1" align="center">
        <CDS.Text10 fontSize="2xs" color="content.tertiary" textTransform="uppercase" lineHeight="1.2">
          {format(startDate, "MMM")}
        </CDS.Text10>
        <CDS.Text12 fontWeight="600" color="content.primary" lineHeight="1.2">
          {format(startDate, "d")}
        </CDS.Text12>
      </VStack>

      <Box flex="1" minW={0}>
        <CDS.Text14 fontSize="13px" color="gray.700" noOfLines={1}>
          {meeting.name}
        </CDS.Text14>
        <HStack spacing="1" mt="0.5">
          <CDS.Text10 color="content.tertiary">
            {dayLabel} · {timeLabel}
          </CDS.Text10>
          {meeting.durationMinutes > 0 && (
            <CDS.Text10 color="content.tertiary">
              · {meeting.durationMinutes}m
            </CDS.Text10>
          )}
        </HStack>
      </Box>

      <GeneralMeetingTypeTag meetingType={meeting.meetingType} />
    </Flex>
  );
}
